(function () {
    'use strict';

    angular
        .module('admin')
        .config(AdminRoute);

    AdminRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function AdminRoute ($stateProvider) {
        $stateProvider
            .state('root.admin', {
                abstract: true,
                url: '/admin',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
            })
            .state ('root.admin.list', {
                url: '/users',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/admin/users/list/list.html',
                        controller: 'UserListController',
                        controllerAs: 'admin',
                        resolve: {
                            users: ['UserService', function(UserService) {
                                return UserService.all();
                            }]
                        }
                    }
                }
            })
            .state('root.admin.create', {
                url:'/users/create',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/admin/users/form/form.html',
                        controller: 'UserFormController',
                        controllerAs: 'create',
                    }
                }
            })
            .state('root.admin.edit', {
                url:'/users/{id}/edit',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/admin/users/form/form.html',
                        controller: 'UserFormController',
                        controllerAs: 'create',
                        resolve: {
                            Areas: ['AreaService', function(AreaService) {
                                return AreaService.getAll().then(function(response){
                                    return response.data;
                                });
                            }]
                        }
                    }
                }
            });
    }
})();